import { GzButtonWebComponent, GzDropdownWebComponent, GzFormFieldWebComponent } from 'apps/webcomponents/src/index.ui';
import { FormGroup } from 'apps/webcomponents/src/ui/gzForm/formGroup/form-group';
import { translateFn } from 'apps/webcomponents/src/utils/translator.helper';
import { html, LitElement } from 'lit';
import { customElement, property, query, state } from 'lit/decorators.js';
import { Subscription } from 'rxjs';
import { styles } from './styles';
import { FormGroupValue } from 'apps/webcomponents/src/ui/gzForm/formGroup/types/form-group-value';
import { FontSizes } from 'apps/webcomponents/src/types/common/types';

@customElement('compliance-manager-contact-form')
export class InProductTrialsComplianceContactUs extends LitElement {
  @query('#complianceForm')
  complianceForm: GzFormFieldWebComponent<GzDropdownWebComponent, string | number>;

  @query('#submit')
  submitBtn: GzButtonWebComponent;

  @property({ type: Function, attribute: false, reflect: false })
  onSubmit: (value: FormGroupValue) => Promise<void>;

  @property({ type: Function, attribute: false, reflect: false })
  onCancel: () => void;

  @state()
  private formGroup: FormGroup | null;

  @state()
  private subscription: Subscription;

  firstUpdated(changedProperties: any) {
    super.firstUpdated(changedProperties);
    this.buildFormGroup();
  }

  static get styles() {
    return styles;
  }

  private buildFormGroup() {
    this.formGroup = FormGroup.build({
      complianceForm: this.complianceForm,
    });

    this.subscription = this.formGroup.valid$.subscribe({
      next: valid => {
        this.submitBtn.disabled = !valid;
      },
    });
  }

  private async handleFormSubmit() {
    if (!this.formGroup) {
      return;
    }

    this.submitBtn.setLoadingState(true);

    await this.onSubmit(this.formGroup.value);

    this.submitBtn.setLoadingState(false);

    this.formGroup.unsubscribe();
    this.subscription.unsubscribe();
  }

  render() {
    return html`
      <div class="d-flex flex-column">
        <gz-text class="mb-2" fontSize="${FontSizes.HEADING_6}"
          >${translateFn("Let us know which compliance standards or product features you'd like to learn more about.")}
        </gz-text>
        <gz-text class="mb-2" fontSize="${FontSizes.HEADING_6}"
          >${translateFn('A Bitdefender representative will be in touch shortly.')}
        </gz-text>
        <gz-form-field id="complianceForm">
          <gz-textarea
            maxLength="500"
            gz-form-input
            type="text"
            class="text-area-input"
            hasCounter="true"
            maxChars="500"
            placeholder="${translateFn('Type here')}"
          >
          </gz-textarea>
        </gz-form-field>
        <div class="d-flex justify-space-between mt-4">
          <gz-button id="submit" @click="${this.handleFormSubmit}">${translateFn('Submit')}</gz-button>
          <gz-button id="cancel" type="outline" color="secondary" @click="${this.onCancel}">
            ${translateFn('Cancel')}
          </gz-button>
        </div>
      </div>
    `;
  }
}
